import { Collection } from '../../interfaces';
import { isEligible } from './isEligible';

export const getEligibleCollections = (collections: Collection[]): Collection[] => {
  const eligibleCollections = collections.filter((collection) => isEligible(collection));

  return eligibleCollections;
};
